import { usePointSetCompanyTagsMutation, PointPureSetCompanyTagsMutationInput } from '@shared/api/graphql/generated';
import { FetchPolicyKeys, BaseMutationResultType } from '@shared/api/graphql/types';

export type PointSetCompanyTagResultType = BaseMutationResultType;

export type UsePointSetCompanyTagsType = [
  request: (input: PointPureSetCompanyTagsMutationInput) => Promise<boolean>,
  result: PointSetCompanyTagResultType,
];

const usePointSetCompanyTags = (): UsePointSetCompanyTagsType => {
  const [createMutation, createMutationResult] = usePointSetCompanyTagsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: PointPureSetCompanyTagsMutationInput) => {
    const newTag = await createMutation({
      variables: {
        input,
      },
    });

    return !!newTag.data?.pointPureSetCompanyTags?.ok;
  };

  const result: PointSetCompanyTagResultType = {
    error: createMutationResult.error,
    loading: createMutationResult.loading,
    called: createMutationResult.called,
  };

  return [request, result];
};

export default usePointSetCompanyTags;
